import { useState, useEffect, useRef } from 'react';

import ProducerSideBar from './components/ProducerSideBar';

import { Get_Subject_ID, get_user } from '../../../api/api'
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';

import { BiTrash } from 'react-icons/bi'

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import useCategoryList from '../../../hooks/useCategoryList';
import usePlatformList from '../../../hooks/usePlatformList';
import useFeatureList from '../../../hooks/useFeatureList';
import { toast } from 'react-toastify';
import CatsPost from './components/CatsPost';
import PlatformsPost from './components/PlatformsPost';
import FeaturesPost from './components/FeaturesPost';
import UploadPoster from './components/UploadPoster';
import PostContentTabs from './components/PostContentTabs';
import PendingPost from './components/PendingPost';

import RichTextEditor from './components/RichTextEditor';
import UploadGallery from './components/UploadGallery';
import { parseMetadataDefaults } from './components/MetadataSelect';
import {
  buildSystemRequirementPayload,
  emptySystemRequirement,
  parseSystemRequirement,
} from './components/systemRequirementHelper';
import { hasComputerPlatformSelected } from './components/platformHelper';
import {
  SUBJECT_TYPES,
  buildVideosPayload,
  parseVideosForEdit,
  parseBranchModelsForEdit,
  sanitizeBranchModelsForSubmit,
} from './components/videoHelper';

const mod = {
     toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          ['blockquote'],
          [{ 'header': 1 }, { 'header': 2 }],
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'direction': 'rtl' }],
          [{ 'size': ['small', false, 'large', 'huge'] }],
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          [{ 'color': [] }, { 'background': [] }],
          [{ 'font': [] }],
          [{ 'align': [] }],
          ['clean', 'link', 'image', 'video']
     ],
}

const EditPost = () => {

     const [loading, setLoading] = useState(true)
     const [response, setResponse] = useState({})
     const [checkedState, setCheckedState] = useState([])
     const [catsArray, setCatsArray] = useState([])
     const [platformIds, setPlatformIds] = useState([])
     const [platformsArray, setPlatformsArray] = useState([])
     const [features, setFeatures] = useState([])
     const [featuresArray, setFeaturesArray] = useState([])
     const [metadata, setMetadata] = useState(null)
     const [metadataDefaults, setMetadataDefaults] = useState(null)
     const [imageId, setImageId] = useState(null)
     const [publishDate, setPublishDate] = useState('')
     const [age, setAge] = useState('')
     const [imagesIds, setImagesIds] = useState([]);
     const [notFound, setNotFound] = useState(false)
     const [pendingPost, setPendingPost] = useState(0)
     const [isPin, setIsPin] = useState(false)
     const [preducer, setPreducer] = useState({
          value: '', label: ''
     });

     const [descriptions, setDescriptions] = useState('')
     const [updateInfo, setUpdateInfo] = useState('')
     const [installationGuide, setInstallationGuide] = useState('')
     const [minimumSystemRequirement, setMinimumSystemRequirement] = useState(emptySystemRequirement())
     const [recommendedSystemRequirement, setRecommendedSystemRequirement] = useState(emptySystemRequirement())

     const [links, setLinks] = useState([])
     const [subjectType, setSubjectType] = useState(SUBJECT_TYPES.GAME)
     const [videos, setVideos] = useState([])

     const uploadFilesCode = useRef(null)

     const prams = useParams()
     const navigate = useNavigate()
     const CategoryList = useCategoryList()
     const PlatformList = usePlatformList()
     const FeatureList = useFeatureList()

     const isVideo = subjectType === SUBJECT_TYPES.VIDEO
     const showSystemRequirements = hasComputerPlatformSelected(platformIds, PlatformList)


     const handleSubmitForm = async (e) => {
          e.preventDefault()


          if (preducer && preducer !== null) {

               let videosPayload = null
               if (isVideo) {
                    const videosResult = buildVideosPayload(videos)
                    if (videosResult.error) {
                         toast.error(videosResult.error)
                         return
                    }
                    videosPayload = videosResult.payload
               }

               setLoading(true);

               //اپلود فایل های امینیتی قبل از ذخیره عنوان
               if (uploadFilesCode.current) {
                    await uploadFilesCode.current.preSubmitAction()
               }

               let data = {
                    type: subjectType,
                    videos: isVideo ? videosPayload : null,
                    categoryIds: checkedState ? checkedState : null,
                    platformIds: platformIds.length ? platformIds : null,
                    features: features.length ? features : null,
                    metadata: metadata?.length ? metadata : null,
                    title: e.target.isTitle.value ? e.target.isTitle.value : null,
                    persianTitle: e.target.persianTitle.value ? e.target.persianTitle.value : null,
                    producerUserId: preducer.value ? preducer.value : preducer,
                    description: descriptions,
                    updateInfo: updateInfo || null,
                    installationGuide: installationGuide || null,
                    minimumSystemRequirement: showSystemRequirements
                         ? buildSystemRequirementPayload(minimumSystemRequirement)
                         : null,
                    recommendedSystemRequirement: showSystemRequirements
                         ? buildSystemRequirementPayload(recommendedSystemRequirement)
                         : null,
                    posterId: imageId ? imageId : null,
                    branchModels: sanitizeBranchModelsForSubmit(links, isVideo),
                    state: pendingPost,
                    size: e.target.size.value !== '' ? parseFloat(e.target.size.value) : null,
                    productionYear: e.target.publishDate.value ? e.target.publishDate.value : 0,
                    version: e.target.version.value,
                    publishDate: publishDate.replaceAll('/', '-').replace(' ', 'T'),
                    ages: age || null,
                    isPin: e.target.isPin.checked,
                    GalleryIds: imagesIds
               }

               try {
                    setLoading(true);
                    await axios.put(Get_Subject_ID + prams.postId, data)
                    toast.success('با موفقیت ویرایش شد!')
               } catch {
                    // پیام خطا در interceptor اکسios توست می‌شود
               } finally {

                    // activationKeyMediaIds reset 
                    setLinks(prevLinks =>
                         prevLinks.map(link => ({
                              ...link,
                              activationKeyMediaIds: link.activationKeyMediaIds ? [] : link.activationKeyMediaIds
                         }))
                    );
                    //end 

                    setLoading(false)
               }

          } else {
               toast.error('لطفا یک تولید کننده انتخاب کنید.')
          }

     }


     const deletePost = () => {
          confirmAlert({
               title: 'اخطار!',
               message: 'آیا از حذف این عنوان مطمئن هستید؟',
               buttons: [
                    {
                         label: 'بله',
                         onClick: async () => {
                              try {
                                   setLoading(true);
                                   await axios.delete(Get_Subject_ID + prams.postId)
                                   navigate('/type', { replace: true })
                              } catch {
                                   // پیام خطا در interceptor اکسios توست می‌شود
                              } finally {
                                   setLoading(false)
                              }
                         }
                    },
                    {
                         label: 'خیر',
                    }
               ]
          });
     }


     useEffect(() => {

          const getContent = async () => {
               try {

                    const res = await axios.get(Get_Subject_ID + prams.postId)
                    setResponse(res.data)
                    setIsPin(res.data.isPin)
                    setDescriptions(res.data.description)
                    setUpdateInfo(res.data.updateInfo || '')
                    setInstallationGuide(res.data.installationGuide || '')
                    setMinimumSystemRequirement(parseSystemRequirement(res.data.minimumSystemRequirement))
                    setRecommendedSystemRequirement(parseSystemRequirement(res.data.recommendedSystemRequirement))
                    setImagesIds(res.data?.galleryIds)
                    setPublishDate(res.data?.publishDate?.replace('T', ' '))
                    setPendingPost(res.data.state.id)
                    setAge(res.data.ages)

                    res.data.posterId && setImageId(res.data.posterId)
                    const catsToArray = res.data.categories.map(i => i.id)
                    setCatsArray(catsToArray)
                    catsToArray && setCheckedState(catsToArray)

                    const platformsToArray = res.data.platformIds || []
                    setPlatformsArray(platformsToArray)
                    setPlatformIds(platformsToArray)

                    const featuresToArray = (res.data.featureItems || []).map((item) =>
                         typeof item === 'object' && item !== null ? item.id : item
                    )
                    setFeaturesArray(featuresToArray)
                    setFeatures(featuresToArray)

                    setMetadataDefaults(parseMetadataDefaults(res.data.metadata))

                    const currentType = res.data.type === SUBJECT_TYPES.VIDEO
                         ? SUBJECT_TYPES.VIDEO
                         : SUBJECT_TYPES.GAME
                    setSubjectType(currentType)

                    setVideos(parseVideosForEdit(res.data.videos, res.data.video))

                    //download links
                    setLinks(parseBranchModelsForEdit(res.data.subjectBranch || [], currentType === SUBJECT_TYPES.VIDEO))


               } catch (error) {
                    console.log(error)
                    setNotFound(true)
               } finally {
                    setLoading(false)
               }
          }
          getContent()

     }, [prams.postId]);


     useEffect(() => {
          const getPreducer = async () => {
               setLoading(true)
               if (!response.producerUserId) return null
               try {
                    const res = await axios.get(get_user(response.producerUserId))
                    setPreducer({ value: response.producerUserId, label: `${res.data.firstName} (${res.data.lastName})` })
               } finally {
                    setLoading(false)
               }
          }

          if (response.producerUserId) getPreducer()
     }, [response]);


     return (
          <>
               {notFound ? (<p style={{ textAlign: 'center', marginTop: '240px' }}><button className='goBack' onClick={() => navigate(-1)}>بازگشت</button></p>) : (

                    <div className="contentHolder">
                         <div className="row">
                              <div className="col-12">
                                   <div className="box_radios padding">
                                        <form onSubmit={handleSubmitForm}>
                                             <p><input name='isTitle' type="text" placeholder="عنوان" defaultValue={response.title} /></p>
                                             <div className="content_flex">

                                                  <div className="flexHolder">
                                                       <p><input type="text" name='persianTitle' placeholder='نام پارسی' defaultValue={response.persianTitle} /></p>

                                                       <div className='textEditor'>
                                                            <RichTextEditor value={descriptions} onChange={setDescriptions} modules={mod} />
                                                       </div>

                                                       <PostContentTabs
                                                            links={links}
                                                            setLinks={setLinks}
                                                            refUploadCode={uploadFilesCode}
                                                            updateInfo={updateInfo}
                                                            setUpdateInfo={setUpdateInfo}
                                                            installationGuide={installationGuide}
                                                            setInstallationGuide={setInstallationGuide}
                                                            minimumSystemRequirement={minimumSystemRequirement}
                                                            setMinimumSystemRequirement={setMinimumSystemRequirement}
                                                            recommendedSystemRequirement={recommendedSystemRequirement}
                                                            setRecommendedSystemRequirement={setRecommendedSystemRequirement}
                                                            showSystemRequirements={showSystemRequirements}
                                                            isVideo={isVideo}
                                                            videos={videos}
                                                            setVideos={setVideos}
                                                       />
                                                  </div>


                                                  <div className="flexHolder">
                                                       <UploadPoster havePoster={response.posterId} pullback={setImageId} setLoading={setLoading} />
                                                       <CatsPost data={CategoryList} pullback={setCheckedState} checked={catsArray} />

                                                       <PlatformsPost data={PlatformList} pullback={setPlatformIds} checked={platformsArray} />

                                                       <FeaturesPost data={FeatureList} pullback={setFeatures} checked={featuresArray} />

                                                       <ProducerSideBar defaultValue={preducer} pullback={setPreducer} metadataPullback={setMetadata} metadataDefaults={metadataDefaults}>
                                                            <p className='w-100'><input type="number" min={1962} max={2040} name='publishDate' placeholder='سال انتشار' defaultValue={response.productionYear} /></p>
                                                            <p className='w-100'><input type="text" name='version' placeholder='ورژن' defaultValue={response.version} /></p>
                                                            <p className='w-100'><input type="number" name='size' step="0.01" placeholder='حجم کل' defaultValue={response.size} required={!isVideo} /></p>
                                                            <p className='w-100'>
                                                                 <select name="age" id="AGE" required={!isVideo} style={{ width: '100%', backgroundColor: '#fff', padding: '8px', fontSize: '14px' }} value={age} onChange={(e) => setAge(e.target.value)} >
                                                                      <option value=''>رده سنی</option>
                                                                      <option value="+3">+3</option>
                                                                      <option value="+7">+7</option>
                                                                      <option value="+12">+12</option>
                                                                      <option value="+15">+15</option>
                                                                      <option value="+18">+18</option>
                                                                 </select>
                                                            </p>
                                                       </ProducerSideBar>

                                                       <PendingPost defaultValue={pendingPost} setPendingPost={setPendingPost} datePublish={publishDate} setDatePublish={setPublishDate}>
                                                            <label htmlFor="isPin">
                                                                 <input type="checkbox" name="isPin" id="isPin" onChange={(e) => setIsPin(e.target.checked)} checked={isPin} />
                                                                 <span>سنجاق کردن این نوشته در عناوین</span>
                                                            </label>
                                                       </PendingPost>


                                                       <UploadGallery havePoster={false} pullback={setImagesIds} images={imagesIds} setLoading={setLoading} />



                                                       <div className="bot" style={{ display: 'flex' }}>

                                                            {loading
                                                                 ?
                                                                 <button type='submit' style={{ width: '65%', marginLeft: '7px' }} className='disabled'>لطفا صبر کنید...</button>
                                                                 :
                                                                 <button type='submit' style={{ width: '65%', marginLeft: '7px' }}>ذخیره</button>
                                                            }

                                                            <button onClick={deletePost} type='button' style={{ backgroundColor: '#fff', borderWidth: '2px', fontWeight: 'bold', color: '#f63' }}><BiTrash /> حذف</button>
                                                       </div>
                                                  </div>

                                             </div>
                                        </form>
                                   </div>
                              </div>
                         </div>
                    </div>
               )}
          </>
     )
}
export default EditPost